import { render, staticRenderFns } from "./IncomeChart.vue?vue&type=template&id=15041c01&"
import script from "./IncomeChart.vue?vue&type=script&lang=js&"
export * from "./IncomeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports